import React, { useState, useEffect } from 'react';

import { types } from '@sunwisesoftware/sunwise-template-core';
import { push } from 'connected-react-router';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';

import reportTemplateReview from '../reportTemplateReview';

import * as actions from './actions';
import * as selectors from './selectors';

const Container = ({
    canModify,
    fetchReportDetails,
    handleClickBreadcrumb,
    isFetchingReportDetails,
    match,
    reportDetails,
}) => {
    const { t } = useTranslation();
    const [editionDisabled, setEditionDisabled] = useState(true);

    useEffect(() => {
        fetchReportDetails(match.params.uid);
    }, []);

    if (isFetchingReportDetails) return null;

    return (
        <reportTemplateReview.Container
            breadcrumbLocations={[
                {
                    label: reportDetails?.project?.name || null,
                    action: () =>
                        handleClickBreadcrumb(
                            null,
                            reportDetails?.credit_product,
                        ),
                },
                {
                    label: reportDetails?.name || null,
                    action: () => handleClickBreadcrumb(match.params.uid),
                },
            ]}
            canModify={canModify}
            currentBreadcrumb={t('Preview')}
            editionDisabled={editionDisabled}
            isFetching={isFetchingReportDetails}
            reportDetails={reportDetails}
            setEditionDisabled={setEditionDisabled}
            templateType={types.REPORT_TYPE ?? 3}
        />
    );
};

const mapStateToProps = createStructuredSelector({
    reportDetails: selectors.getReportDetailsData,
    isFetchingReportDetails: selectors.getIsFetchingReportDetails,
});

const mapDispatchToProps = (dispatch) => ({
    fetchReportDetails: (id) => dispatch(actions.fetchReportDetails(id)),
    handleClickBreadcrumb: (reportId, creditId) =>
        dispatch(actions.handleClickBreadcrumb(reportId, creditId)),
    redirect: (link) => dispatch(push(link)),
});

Container.propTypes = {
    canModify: PropTypes.bool,
    fetchReportDetails: PropTypes.func,
    handleClickBreadcrumb: PropTypes.func,
    isFetchingReportDetails: PropTypes.bool,
    match: PropTypes.object,
    reportDetails: PropTypes.object,
};

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withRouter,
)(Container);
